import { ComponentType } from 'react';

import { ScSlideGridContainer, ScSlideGridContainerProps } from './styled';

export interface SlideGridContainerProps<T> extends ScSlideGridContainerProps {
  itemsGroup: T[];
  itemComponent: ComponentType<T>;
}

export function SlideGridContainer<T>({
  itemsGroup,
  itemComponent: Item,
  ...props
}: SlideGridContainerProps<T>) {
  return (
    <ScSlideGridContainer {...props}>
      {itemsGroup.map((item, i) => (
        <Item {...item} key={i} />
      ))}
    </ScSlideGridContainer>
  );
}
